import { COOKIE_NAME_DRAFT_MODE } from '~/types/cookieNames';
import { useIsInIframe } from '~/composables/useIsInIframe';

/**
 * Returns the current state of the draft mode.
 */
export const useDraftMode = () => {
    const draftModeCookie = useCookie<string | undefined>(COOKIE_NAME_DRAFT_MODE);
    const isDraftModeEnabled = computed(() => Boolean(draftModeCookie.value));
    const isInEditor = computed(() => draftModeCookie.value && useIsInIframe());

    /**
     * Show the toggle when in Draft mode, but never when using the Visual Editor
     * in Storyblok. You would never able to properly leave the draft mode there.
     * Also, this would confuse users of the Visual Editor since its intended use case
     * is to preview draft content.
     */
    const showDraftModeToggle = computed(() => {
        if (!isDraftModeEnabled.value) return false;
        if (useIsInIframe()) return false;
        return true;
    });

    return { isDraftModeEnabled, showDraftModeToggle, isInEditor };
};
